"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var idlUtils = require("../generated/utils");

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var HTMLHyperlinkElementUtilsImpl = require("./HTMLHyperlinkElementUtils-impl").implementation;

var HTMLAreaElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLAreaElementImpl, _HTMLElementImpl);

  function HTMLAreaElementImpl(args, privateData) {
    var _this;

    _classCallCheck(this, HTMLAreaElementImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HTMLAreaElementImpl).call(this, args, privateData));

    _this._htmlHyperlinkElementUtilsSetup();

    return _this;
  }

  return HTMLAreaElementImpl;
}(HTMLElementImpl);

idlUtils.mixin(HTMLAreaElementImpl.prototype, HTMLHyperlinkElementUtilsImpl.prototype);
module.exports = {
  implementation: HTMLAreaElementImpl
};